/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M8 5V4H6.5v1h-1C4 5 4 6.5 4 6.5v12S4 20 5.5 20h13s1.5 0 1.5-1.5v-12S20 5 18.5 5h-1V4H16v1zm10.5 1.5V8h-13V6.5zm-13 3h13v9h-13z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M7 11h2v2H7zm8 0h2v2h-2zm-2 0h-2v2h2z" clipRule="evenodd" /></svg>;
export default SvgCalendar;